import React, { useEffect, useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import "./BackToTop.css";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const goToBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const listenToScroll = () => {
    let heightToHidden = 250;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToHidden) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  };

  const debouncedFilter = debounce(listenToScroll, 300);

  useEffect(() => {
    window.addEventListener("scroll", debouncedFilter);
    return () => window.removeEventListener("scroll", debouncedFilter);
  }, [debouncedFilter]);

  return React.createElement(
    "div",
    { className: "wrapper" },
    isVisible &&
      React.createElement(
        "div",
        { className: "top-btn", onClick: goToBtn },
        React.createElement(IoIosArrowUp, { className: "icon" })
      )
  );
};

export default BackToTop;
